import { Progress } from '@agro-club/agroclub-shared'
import { useAProgress } from 'hooks/useAProgress'
import { useNotification } from 'hooks/useNotification'
import { Bid, BidStatus } from 'modules/domain/bid/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AButton } from 'views/components/Analytics'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { SharedModalContent, SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { AnalyticsPlaces } from '../../analyticsPlaces'

type Props = {
  bid: Bid
}

export const ArchiveBidButton: FC<Props> = ({ bid }) => {
  const { t } = useTranslation('bid')
  const { id, status } = bid
  const navigate = useNavigate()
  const notify = useNotification()
  const [isConfirmVisible, setConfirmVisible] = useState<boolean>(false)
  const [changeStatusProgress, changeStatus] = useAProgress(
    () => apiClient.post(endpoints.bidChangeStatus(id), { new_status: BidStatus.archived }),
    {
      eventName: 'archive',
      onSuccess: () => {
        setConfirmVisible(false)
        navigate(-1)
        notify(Progress.SUCCESS, { title: t('notifyEditArchived') })
      },
    },
  )

  return (
    <>
      <AButton
        color="destruct"
        size="medium"
        onClick={() => setConfirmVisible(true)}
        disabled={status == BidStatus.archived}
        id="archive"
        analyticsPayload={{ id }}
      >
        {t('common:archive')}
      </AButton>

      {isConfirmVisible && (
        <ASharedModal onClose={() => setConfirmVisible(false)} size="small" id={AnalyticsPlaces.ARCHIVE_MODAL}>
          <SharedModalTitle>{t('archiveBid')}</SharedModalTitle>
          <SharedModalContent>{t('areYouSureToArchiveBid')}</SharedModalContent>
          <ADefaultModalFooter
            onConfirm={changeStatus}
            confirmButtonText={t('common:archive')}
            progress={changeStatusProgress}
            onClose={() => setConfirmVisible(false)}
          />
        </ASharedModal>
      )}
    </>
  )
}
